"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TemplateOption;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _ykbUtils = require("ykb-utils");
var _legacyUtil = require("./legacyUtil");
var _StyledSelect = require("./StyledSelect");
var _excluded = ["template", "theme", "searchText", "multiColumnTagLabelKey", "option", "viewMode", "allowTurkishSearch"];
function TemplateOption(props) {
  var _props$template = props.template,
    columnHeaders = _props$template.columnHeaders,
    captionLabelKeys = _props$template.captionLabelKeys,
    columnLabelKeys = _props$template.columnLabelKeys,
    avatarUrlLabelKey = _props$template.avatarUrlLabelKey,
    theme = props.theme,
    searchText = props.searchText,
    multiColumnTagLabelKey = props.multiColumnTagLabelKey,
    option = props.option,
    _props$viewMode = props.viewMode,
    viewMode = _props$viewMode === void 0 ? false : _props$viewMode,
    allowTurkishSearch = props.allowTurkishSearch,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var $$data = rest.$$data;
  var colSpan = captionLabelKeys && captionLabelKeys.length ? 24 / (columnHeaders.length + 1) : 24 / columnHeaders.length;
  var useHighlight = function useHighlight(text) {
    var source = (0, _legacyUtil.toTurkishLowerCase)(text);
    if (!(0, _ykbUtils.isNullOrUndefined)(source)) {
      var firstIndex = allowTurkishSearch ? (0, _ykbUtils.compareLowerCase)(searchText, String(source), true) : String(source).indexOf((0, _legacyUtil.toTurkishLowerCase)(searchText));
      if (firstIndex >= 0) {
        var length = searchText.length;
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, String(text).slice(0, firstIndex), /*#__PURE__*/_react.default.createElement("mark", null, String(text).slice(firstIndex, firstIndex + length)), String(text).slice(firstIndex + length));
      }
    }
    return text;
  };
  var getCaption = function getCaption(labelKey, index) {
    if (index === 0) {
      $$data = option[multiColumnTagLabelKey || labelKey];
    }
    return /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCol, {
      key: index,
      theme: theme,
      span: 24
    }, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCaption, {
      theme: theme,
      $index: index,
      $viewMode: viewMode
    }, useHighlight(option[labelKey])));
  };
  var captionColumns = captionLabelKeys && captionLabelKeys.length && /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCol, {
    theme: theme,
    xs: 24,
    sm: 24,
    md: 24,
    lg: colSpan
  }, captionLabelKeys.map(getCaption));
  var labelColumns = columnHeaders.length && columnHeaders.map(function (header, index) {
    var labelKey = columnLabelKeys[index];
    return /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCol, {
      key: index,
      theme: theme,
      xs: 24,
      sm: 24,
      md: 24,
      lg: colSpan
    }, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCol, {
      theme: theme,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 24
    }, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCell, {
      theme: theme,
      $header: true,
      $viewMode: viewMode
    }, header)), /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCol, {
      theme: theme,
      xs: 12,
      sm: 12,
      md: 12,
      lg: 24
    }, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateCell, {
      theme: theme,
      $text: true,
      $viewMode: viewMode
    }, useHighlight(option[labelKey]))));
  });
  return /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateRow, {
    theme: theme,
    $$data: $$data
  }, avatarUrlLabelKey ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateAvatar, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateAvatarContent, {
    theme: theme,
    src: option[avatarUrlLabelKey]
  })), /*#__PURE__*/_react.default.createElement(_StyledSelect.StyledTemplateContent, {
    theme: theme
  }, captionColumns, labelColumns)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, captionColumns, labelColumns));
}